// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.cdv-200 {
  background-color: #2E7D32;
  color: white;
}

.cdv-201 {
  background-color: #0EA501;
  color: white;
}

.cdv-202 {
  background-color: #7CB342;
  color: white;
}

.cdv-203 {
  background-color: #1976D2;
  color: white;
}

.cdv-204 {
  background-color: #FFA500;
  color: white;
}

.cdv-205 {
  background-color: #1B5E20;
  color: white;
}

.cdv-206 {
  background-color: #FFB300;
  color: white;
}

.cdv-207 {
  background-color: #C2185B;
  color: white;
}

.cdv-208 {
  background-color: #6A1B9A;
  color: white;
}

.cdv-209 {
  background-color: #004D40;
  color: white;
}

.cdv-210 {
  background-color: #D32F2F;
  color: white;
}

.cdv-211 {
  background-color: #3949AB;
  color: white;
}

.cdv-212 {
  background-color: #00897B;
  color: white;
}

.cdv-213 {
  background-color: #263238;
  color: white;
}

#horizontalTable th,
#horizontalTable td {
  padding-left: 0;
  text-align: left;
}

.cdv-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
  white-space: nowrap;
  width: max-content;
}

.cdv-text {
  white-space: nowrap;
}

.cdv-code {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 24px;
  padding: 0 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  flex-shrink: 0;
}

.phase-305 {
  background-color: #2E7D32;
  color: white;
}

.phase-23 {
  background-color: #FFA500;
  color: white;
}

td {
  padding: 3px 10px;
}

.history-header {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #35364A;
  color: white;
  padding: 8px 0;
}

.btn-options {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-option {
  cursor: pointer;
}

.btn-option input {
  display: none;
}

.btn-label-current {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  text-transform: none;
  margin-left: 10px;
  padding: 12px 20px;
  border-radius: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

/* base: già colorato con cdv */
.btn-label {
  display: inline-block;
  padding: 12px 20px;
  border-radius: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  border: 2px solid transparent;
}

/* 🔥 hover leggero */
.btn-label:hover {
  filter: brightness(1.1);
}

/* 🔥 stato selezionato */
.btn-option input:checked + .btn-label {
  filter: brightness(0.6); /* più scuro */
  transform: scale(0.97);
  border: 2px solid rgba(0, 0, 0, 0.2509803922); /* bordo evidenziato */
}

.status-text {
  font-weight: 600;
}

.status-sub {
  font-size: 0.75em;
  font-style: italic;
  margin-top: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/document/cdv/cdv-event/cdv-event.component.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AC0BhB;EAAW,yBAAA;EAA2B,YAAA;ADtBtC;;ACuBA;EAAW,yBAAA;EAA2B,YAAA;ADlBtC;;ACmBA;EAAW,yBAAA;EAA2B,YAAA;ADdtC;;ACeA;EAAW,yBAAA;EAA2B,YAAA;ADVtC;;ACWA;EAAW,yBAAA;EAA2B,YAAA;ADNtC;;ACOA;EAAW,yBAAA;EAA2B,YAAA;ADFtC;;ACGA;EAAW,yBAAA;EAA2B,YAAA;ADEtC;;ACDA;EAAW,yBAAA;EAA2B,YAAA;ADMtC;;ACLA;EAAW,yBAAA;EAA2B,YAAA;ADUtC;;ACTA;EAAW,yBAAA;EAA2B,YAAA;ADctC;;ACbA;EAAW,yBAAA;EAA2B,YAAA;ADkBtC;;ACjBA;EAAW,yBAAA;EAA2B,YAAA;ADsBtC;;ACrBA;EAAW,yBAAA;EAA2B,YAAA;AD0BtC;;ACzBA;EAAW,yBAAA;EAA2B,YAAA;AD8BtC;;AAnEA;;EAEE,eAAA;EACA,gBAAA;AAsEF;;AAnEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAsEF;;AAnEA;EACE,mBAAA;AAsEF;;AAnEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAsEF;;AAnEA;EAAY,yBAAA;EAA2B,YAAA;AAwEvC;;AAvEA;EAAY,yBAAA;EAA2B,YAAA;AA4EvC;;AA1EC;EACG,iBAAA;AA6EJ;;AA1EA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBC7CkB;ED8ClB,YAAA;EACA,cAAA;AA6EF;;AA1EA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA6EF;;AA1EA;EACE,eAAA;AA6EF;;AA1EA;EACE,aAAA;AA6EF;;AA1EC;EACC,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;AA6EF;;AA1EA,+BAAA;AACA;EACE,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BAAA;AA6EF;;AAzEA,qBAAA;AACA;EACE,uBAAA;AA4EF;;AAzEA,yBAAA;AACA;EACE,uBAAA,EAAA,cAAA;EACA,sBAAA;EACA,6CAAA,EAAA,sBAAA;AA4EF;;AAzEA;EACE,gBAAA;AA4EF;;AAzEA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;AA4EF","sourcesContent":["@import \"../../../../../../src/scss/_variables.scss\";\r\n\r\n#horizontalTable th,\r\n#horizontalTable td {\r\n  padding-left: 0;\r\n  text-align: left;\r\n}\r\n\r\n.cdv-inline {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  flex-wrap: nowrap;\r\n  white-space: nowrap;\r\n  width: max-content;\r\n}\r\n\r\n.cdv-text {\r\n  white-space: nowrap;\r\n}\r\n\r\n.cdv-code {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-width: 36px;\r\n  height: 24px;\r\n  padding: 0 8px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.phase-305{ background-color: #2E7D32; color: white; } \r\n.phase-23 { background-color: #FFA500; color: white; } \r\n\r\n td {\r\n    padding: 3px 10px;\r\n  }\r\n  \r\n.history-header {\r\n  display: flex;\r\n  justify-content: center;   // centro orizzontale\r\n  align-items: center;       // centro verticale\r\n  background-color: $mat-primary-color;\r\n  color: white;\r\n  padding: 8px 0;            // riduce l’altezza\r\n}\r\n\r\n.btn-options {\r\n  display: flex;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.btn-option {\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-option input {\r\n  display: none;\r\n}\r\n\r\n .btn-label-current {\r\n  display: inline-flex;;\r\n  flex-direction: column;\r\n  align-items: center;  \r\n  text-transform: none;  \r\n  margin-left: 10px;\r\n  padding: 12px 20px;\r\n  border-radius: 14px;  \r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n/* base: già colorato con cdv */\r\n.btn-label {\r\n  display: inline-block;\r\n  padding: 12px 20px;\r\n  border-radius: 14px;  \r\n  font-weight: 600;\r\n  transition: all 0.2s ease;\r\n  border: 2px solid transparent;\r\n}\r\n\r\n\r\n/* 🔥 hover leggero */\r\n.btn-label:hover {\r\n  filter: brightness(1.1);\r\n}\r\n\r\n/* 🔥 stato selezionato */\r\n.btn-option input:checked + .btn-label {\r\n  filter: brightness(0.6);   /* più scuro */\r\n  transform: scale(0.97);\r\n  border: 2px solid #00000040; /* bordo evidenziato */\r\n}\r\n\r\n.status-text {\r\n  font-weight: 600;\r\n}\r\n\r\n.status-sub {\r\n  font-size: 0.75em;\r\n  font-style: italic;\r\n  margin-top: 2px;\r\n}","// Variabile che è possibile richiamare dagli altri file scss\r\n$mat-primary-color: #35364A;\r\n\r\n$mat-secondary-color: #35364A;\r\n\r\n$navbar-text-selected: #00857E;\r\n\r\n$navbar-gray-text: #555667;\r\n\r\n$navbar-white-text: #FFFF;\r\n\r\n$error-color: #B50600;\r\n$warning-color: #C65015;\r\n$success-color: #056E4B;\r\n\r\n\r\n// Larghezza della sidebar\r\n$navbar-brand-width: 300px !default;\r\n$sidebar-width: 300px !default;\r\n\r\n// Logica usata\r\n//  Verde → esito positivo\r\n//  Blu → stato informativo / di sistema\r\n//  Arancio / Giallo → attenzione / transizione\r\n//  Rosso / Nero → rifiuti\r\n\r\n.cdv-200 { background-color: #2E7D32; color: white; } \r\n.cdv-201 { background-color: #0EA501; color: white; } \r\n.cdv-202 { background-color: #7CB342; color: white; } \r\n.cdv-203 { background-color: #1976D2; color: white; } \r\n.cdv-204 { background-color: #FFA500; color: white; } \r\n.cdv-205 { background-color: #1B5E20; color: white; } \r\n.cdv-206 { background-color: #FFB300; color: white; } \r\n.cdv-207 { background-color: #C2185B; color: white; } \r\n.cdv-208 { background-color: #6A1B9A; color: white; } \r\n.cdv-209 { background-color: #004D40; color: white; } \r\n.cdv-210 { background-color: #D32F2F; color: white; } \r\n.cdv-211 { background-color: #3949AB; color: white; } \r\n.cdv-212 { background-color: #00897B; color: white; } \r\n.cdv-213 { background-color: #263238; color: white; } "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
